/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessChannel
 */
export interface AccessChannel {
    /**
     * 
     * @type {string}
     * @memberof AccessChannel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessChannel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessChannel
     */
    hostname?: string;
}

export function AccessChannelFromJSON(json: any): AccessChannel {
    return AccessChannelFromJSONTyped(json, false);
}

export function AccessChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessChannel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'hostname': !exists(json, 'hostname') ? undefined : json['hostname'],
    };
}

export function AccessChannelToJSON(value?: AccessChannel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'hostname': value.hostname,
    };
}


